import { render, staticRenderFns } from "./ConsignmentSummaryReportAmtTable.vue?vue&type=template&id=4d3087ce&scoped=true"
import script from "./ConsignmentSummaryReportAmtTable.vue?vue&type=script&lang=js"
export * from "./ConsignmentSummaryReportAmtTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3087ce",
  null
  
)

export default component.exports